var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BadgeCampaignList",
      "extra-items": [{
        text: '徽章管理',
        to: 'BadgeListByBadgeCampaign',
        params: {
          merchantId: _vm.$route.params.merchantId,
          badgeCampaignId: _vm.$route.params.badgeCampaignId
        }
      }, {
        text: _vm.badge.name,
        to: 'BadgeViewByBadgeCampaign',
        params: {
          merchantId: _vm.$route.params.merchantId,
          badgeCampaignId: _vm.$route.params.badgeCampaignId,
          badgeId: _vm.$route.params.badgeId
        }
      }, {
        text: '會員列表'
      }]
    }
  })], 1)]), _c('b-overlay', {
    attrs: {
      "show": _vm.isFetching
    }
  }, [_c('b-card', [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v(_vm._s("\u5DF2\u64C1\u6709".concat(_vm.badge.name, "\u5FBD\u7AE0\u7684\u6703\u54E1")))]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('div', [_c('StaffAddCustomer', {
    ref: "staffAddCustomer",
    attrs: {
      "add-button-text": "加入會員"
    },
    on: {
      "bind": _vm.bindCustomer
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.customers,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_vm._v(_vm._s(_vm._f("hiddenString")(data.item.name, 20)))])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex justify-content-center"
        }, [_c('b-button', {
          attrs: {
            "variant": "inverse-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.unbindCustomer(data.item);
            }
          }
        }, [_vm._v(" 移除會員 ")])], 1)];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "change": _vm.fetchCustomers
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }